import { Box } from "@mui/material";
import Footer from "../footer/footer";
import Header from "../header/header";

export default function Loyout({ children }: Readonly<{ children: React.ReactNode }>) {
    return (
        <Box
            sx={{
                minHeight: "100vh",
                display: "flex",
                flexDirection: "column",
                bgcolor: "background.default",
            }}
        >
            <Header />
            <Box component="main" sx={{ flex: 1, display: "flex", flexDirection: "column" }}>
                {children}
            </Box>
            <Footer />
        </Box>
    );
}